import { useBetween } from "use-between";
import { useSelector } from "react-redux";
import { useState } from "react";

const useUserInfo = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedState));

  // Eye Vars
  const [eyeNewPassword, setEyeNewPassword] = useState(true);
  const [eyeOldPassword, setEyeOldPassword] = useState(true);
  const [eyeConfirmPassword, setEyeConfirmPassword] = useState(true);
  const [passwordNewType, setPasswordNewType] = useState("password");
  const [passwordOldType, setPasswordOldType] = useState("password");
  const [passwordConfirmType, setPasswordConfirmType] = useState("password");

  // Input Vars
  const [UserName, setUserName] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [OldPassword, setOldPassword] = useState("");
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");
  const [CorrectPassword, setCorrectPassword] = useState("123");

  // Error Messages
  const [UserNameError, setUserNameError] = useState("user-name-error");
  const [PhoneNumberError, setPhoneNumberError] =
    useState("phone-number-error");
  const [PasswordError, setPasswordError] = useState("password-error");
  const [ConfirmPasswordError, setConfirmPasswordError] = useState(
    "confirm-password-error"
  );

  // Regular Expressions
  const regExpPhoneNumber = new RegExp(
    "^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$"
  ); //+919367788755
  const regExpUserName = new RegExp(
    "^(?=[a-zA-Z0-9._]{8,20}$)(?!.*[_.]{2})[^_.].*[^_.]$"
  ); //user name of 8-20 charachter

  const Eye = (index) => {
    if (index === 0) {
      // Old Password
      if (passwordOldType === "password") {
        setPasswordOldType("text");
        setEyeOldPassword(false);
      } else {
        setPasswordOldType("password");
        setEyeOldPassword(true);
      }
    } else if (index === 1) {
      // New Password
      if (passwordNewType === "password") {
        setPasswordNewType("text");
        setEyeNewPassword(false);
      } else {
        setPasswordNewType("password");
        setEyeNewPassword(true);
      }
    } else {
      // Confirm Pass
      if (passwordConfirmType === "password") {
        setPasswordConfirmType("text");
        setEyeConfirmPassword(false);
      } else {
        setPasswordConfirmType("password");
        setEyeConfirmPassword(true);
      }
    }
  };

  const onChangeInput = (event, inputID) => {
    document.getElementById(inputID).classList.remove("is-invalid");
    if (inputID === "system-user-name-change-label") {
      setUserName(event.target.value);
    } else if (inputID === "system-phone-change-label") {
      setPhoneNumber(event.target.value);
    } else if (inputID === "system-old-password-change-label") {
      setOldPassword(event.target.value);
    } else if (inputID === "system-password-change-label") {
      setNewPassword(event.target.value);
    } else if (inputID === "system-confirm-password-change-label") {
      setConfirmPassword(event.target.value);
    }
  };

  const checkInput = (e) => {
    e.preventDefault();
    if (
      UserName === "" ||
      PhoneNumber === "" ||
      OldPassword === "" ||
      NewPassword === "" ||
      ConfirmPassword === ""
    ) {
      setUserNameError("user-name-error");
      setPhoneNumberError("phone-number-error");
      setPasswordError("password-error");
      setConfirmPasswordError("confirm-password-error");

      if (UserName === "")
        document
          .getElementById("system-user-name-change-label")
          .classList.add("is-invalid");
      if (PhoneNumber === "")
        document
          .getElementById("system-phone-change-label")
          .classList.add("is-invalid");
      if (OldPassword === "")
        document
          .getElementById("system-old-password-change-label")
          .classList.add("is-invalid");
      if (NewPassword === "")
        document
          .getElementById("system-password-change-label")
          .classList.add("is-invalid");
      if (ConfirmPassword === "")
        document
          .getElementById("system-confirm-password-change-label")
          .classList.add("is-invalid");
    } else {
      if (OldPassword !== CorrectPassword) {
        setPasswordError("password-input-error");
        document
          .getElementById("system-old-password-change-label")
          .classList.add("is-invalid");
      }
      if (NewPassword !== ConfirmPassword) {
        setConfirmPasswordError("confirm-password-input-error");
        document
          .getElementById("system-confirm-password-change-label")
          .classList.add("is-invalid");
      }
      if (!regExpPhoneNumber.test(PhoneNumber)) {
        setPhoneNumberError("phone-number-input-error");
        document
          .getElementById("system-phone-change-label")
          .classList.add("is-invalid");
      }
      if (!regExpUserName.test(UserName)) {
        setUserNameError("user-name-input-error");
        document
          .getElementById("system-user-name-change-label")
          .classList.add("is-invalid");
      }
    }
  };
  return {
    locale,
    eyeNewPassword,
    eyeOldPassword,
    eyeConfirmPassword,
    passwordNewType,
    passwordOldType,
    passwordConfirmType,
    UserNameError,
    PhoneNumberError,
    PasswordError,
    ConfirmPasswordError,
    Eye,
    onChangeInput,
    checkInput,
  };
};

export default useUserInfo;
